var __TEMP__ = require('./_baseSetToString.js');var baseSetToString = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_shortOut.js');var shortOut = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = setToString;
